module.exports = __webpack_public_path__ + "teleTwo-4a70fcce70ca3ad72ebdfab92f50c05e.png";